import { render, staticRenderFns } from "./categoryDia.vue?vue&type=template&id=5ecc1f52&scoped=true"
import script from "./categoryDia.vue?vue&type=script&lang=js"
export * from "./categoryDia.vue?vue&type=script&lang=js"
import style0 from "./categoryDia.vue?vue&type=style&index=0&id=5ecc1f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc1f52",
  null
  
)

export default component.exports